import {
    HTTP
} from "@/utilities/http-common";

import _ from 'lodash';

export default {
    namespaced: true,
    state: {
        entries: [{
                id: 1,
                thick_or_thin: "",
                fn_objective_1: 0.18,
                species_1: "Pf",
                vol_blood_1: 0.00135,
                mcr_result_1: 'Pos',
                gametocytes_1: "Yes",
                asx_para_1: 11,
                rbc_density_base_1: 1,
                rbc_density_exponent_1: 1,
                para_density_1: 1,
                fn_objective_2: 0.18,
                species_2: "Pf",
                vol_blood_2: 0.00135,
                mcr_result_2: 'Pos',
                gametocytes_2: "Yes",
                asx_para_2: 11,
                rbc_density_base_2: 1,
                rbc_density_exponent_2: 1,
                para_density_2: 1,
                fn_objective_3: 0.18,
                species_3: "Pf",
                vol_blood_3: 0.00135,
                mcr_result_3: 'Pos',
                gametocytes_3: "Yes",
                asx_para_3: 11,
                rbc_density_base_3: 1,
                rbc_density_exponent_3: 1,
                para_density_3: 1,
            },
            {
                id: 2,
                thick_or_thin: "thick",
                fn_objective_1: 0.18,
                species_1: "Pf",
                vol_blood_1: 0.00135,
                mcr_result_1: 'Pos',
                gametocytes_1: "Yes",
                asx_para_1: 11,
                rbc_density_base_1: 1,
                rbc_density_exponent_1: 1,
                para_density_1: 1,
                fn_objective_2: 0.18,
                species_2: "Pf",
                vol_blood_2: 0.00135,
                mcr_result_2: 'Pos',
                gametocytes_2: "Yes",
                asx_para_2: 11,
                rbc_density_base_2: 1,
                rbc_density_exponent_2: 1,
                para_density_2: 1,
                fn_objective_3: 0.18,
                species_3: "Pf",
                vol_blood_3: 0.00135,
                mcr_result_3: 'Pos',
                gametocytes_3: "Yes",
                asx_para_3: 11,
                rbc_density_base_3: 1,
                rbc_density_exponent_3: 1,
                para_density_3: 1,
            },
            {
                id: 3,
                thick_or_thin: "thin",
                fn_objective_1: 0.18,
                species_1: "Pf",
                vol_blood_1: 0.00135,
                mcr_result_1: 'Pos',
                gametocytes_1: "Yes",
                asx_para_1: 11,
                rbc_density_base_1: 1,
                rbc_density_exponent_1: 1,
                para_density_1: 1,
                fn_objective_2: 0.18,
                species_2: "Pf",
                vol_blood_2: 0.00135,
                mcr_result_2: 'Pos',
                gametocytes_2: "Yes",
                asx_para_2: 11,
                rbc_density_base_2: 1,
                rbc_density_exponent_2: 1,
                para_density_2: 1,
                fn_objective_3: 0.18,
                species_3: "Pf",
                vol_blood_3: 0.00135,
                mcr_result_3: 'Pos',
                gametocytes_3: "Yes",
                asx_para_3: 11,
                rbc_density_base_3: 1,
                rbc_density_exponent_3: 1,
                para_density_3: 1,
            }
        ],
        entry: {}
    },
    getters: {
        getByIndex: (state) => (index) => {
            return state.entries.find((entry, idx) => idx === index);
          }
    },
    mutations: {
        updateThickOrThin(state, payload) {
            state.entries[payload.index].thick_or_thin = payload.thickOrThin;
        },
        updateEntry(state, payload) {
            state.entry[payload.index] = _.assign(state.entries[payload.index], payload);
        }
    },
    actions: {
        getEntries() {
            return HTTP.get("/kenya/subject-microscopy");
        },
        updateThickOrThin({
            commit
        }, payload) {
            commit("updateThickOrThin", payload);
        },
        updateEntry({
            commit
        }, payload) {
            commit("updateEntry", payload);
        }
    }
};
